module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-component'), (_vm.showPopupBirthday) ? _c('div', {
    staticClass: "background-popup-birthday"
  }, [_c('div', {
    staticClass: "popup-birthday"
  }, [_c('div', {
    staticClass: "popup-birthday-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "popup-birthday-header-close",
    on: {
      "click": _vm.cerrarPopupBirthday
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-times-circle"
  })])]), _vm._m(1)])]) : _vm._e(), _c('component-mis-documentos-sin-cargar'), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalDelegacion) ? _c('div', {
    staticClass: "background-popup-birthday"
  }, [_c('div', {
    staticClass: "modal is-active"
  }, [_c('gestion-delegacion-guardar', {
    attrs: {
      "info": _vm.info,
      "isCreatingSelf": true
    },
    on: {
      "close": function($event) {
        _vm.mostrarModalDelegacion = false
      }
    }
  })], 1)]) : _vm._e()]), (_vm.showSidebarMobile) ? _c('div', {
    staticClass: "background-sidebar",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('setSidebarMobile', false)
      }
    }
  }) : _vm._e(), _c('sidebar', {
    on: {
      "delegacion": function($event) {
        _vm.mostrarModalDelegacion = true
      }
    }
  }), _c('div', {
    staticClass: "position-b-sidebar",
    class: _vm.showSidebarDesktop ? 'left-sidebar' : '',
    on: {
      "click": function($event) {
        return _vm.sidebarHide()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-1x",
    class: _vm.showSidebarDesktop ? 'fa-caret-left' : 'fa-caret-right'
  })]), _c('div', {
    staticClass: "contenedor",
    class: !_vm.showSidebarDesktop ? 'padding-left-sidebar' : ''
  }, [_c('div', {
    staticClass: "is-fluid is-marginless padding-20 min-height-full"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)]), _c('notifications'), _c('bottom-bar', {
    staticClass: "app-bottom-bar"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-birthday-header-title"
  }, [_vm._v("¡Feliz cumpleaños! "), _c('span', [_c('i', {
    staticClass: "fa fa-birthday-cake"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-birthday-body"
  }, [_c('div', {
    staticClass: "popup-birthday-body-title"
  }, [_vm._v("Hoy es tu cumpleaños, te deseamos lo mejor en este día especial.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb0f8dc6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Admin_App.vue
// module id = 891
// module chunks = 0